const NoSitePage = () => {
  return null;
};

export default NoSitePage;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/pages/NoSitePage.js